import { withSeasonOccurredModelStatistics } from "./leagueMatchdayAnalysis";

export async function refreshLeagueEvaluationData({
  fixtureIds,
  seasonFixtures,
  fetchComparison,
  refreshFixtureDetails,
}) {
  const [comparison] = await Promise.all([
    fetchComparison(),
    refreshFixtureDetails(fixtureIds),
  ]);
  return withSeasonOccurredModelStatistics(comparison, seasonFixtures);
}
